import { DSQuickLinks } from '../../../cimsPage/instances/ds'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: DSQuickLinks,
  create: 'babb5d9b-f792-49e9-b3ba-9f0a8abed819',
  view: '3bff6c6b-921c-4eb1-a3ca-0c0df66003f5',
  edit: '50c451e7-00cb-458b-9f1f-3feab125a5c8',
  removeRestore: '695957ec-b349-4f6b-9a2c-1ac17ceef9cd',
})

export const CreateDesignSubmittalQuickLink = quickLinks.Create
export const ViewDesignSubmittalQuickLink = quickLinks.View
export const EditDesignSubmittalQuickLink = quickLinks.Edit
export const RemoveRestoreDesignSubmittalQuickLink = quickLinks.RemoveRestore

export type DSQuickLinkPermission =
  | typeof CreateDesignSubmittalQuickLink
  | typeof ViewDesignSubmittalQuickLink
  | typeof EditDesignSubmittalQuickLink
  | typeof RemoveRestoreDesignSubmittalQuickLink
